/** kaizu-api tarafındaki SET_SIZE ile aynı olmalı (mix.config.ts). */
export const SET_SIZE = 20;
